import React from 'react'
import BaseOperatorForm from './BaseOperatorForm'

export default function CreatePrivatePointOperatorForm(props) {
  return <BaseOperatorForm {...props} locationKey="private_point" locationLabel="Социальный объект / МСУ"
    createOperator={props.createPrivatePointOperator} loadOperators={props.loadPrivatePointOperators} />
}
